import i18n from "@/libs/i18n"
import address from "../address"

const otherAddress = () => ({
  id: -1,
  label: i18n.t('Outro'),
  value: { ...address.data().address, id: -1 },
})

const makeAddressOption = addressObject => {
  const addressLabel = address.methods.formatAddress(addressObject)
  return {
    id: addressLabel,
    label: addressLabel,
    value: { ...addressObject, zipcode: addressObject.zipcode.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})$/g, '$1.$2-$3') }
  }
}

const IBGE_PROVINCE_CODES = {
  RO: 11, AC: 12, AM: 13, RR: 14, PA: 15, AP: 16, TO: 17,
  MA: 21, PI: 22, PB: 25, CE: 23, RN: 24, PE: 26, AL: 27, SE: 28, BA: 29,
  MG: 31, ES: 32, RJ: 33, SP: 35,
  PR: 41, SC: 42, RS: 43,
  MS: 50, MT: 51, GO: 52, DF: 53,
}

const addressUtils = {
  validateProvinceCityCode(province, cityCode) {
    const expected = IBGE_PROVINCE_CODES[String(province || '').toUpperCase()]
    const code = String(cityCode || '')
    if (!expected || code.length < 2 || Number(code) === 0) return true

    return Number(code.substring(0, 2)) === expected
  },
  otherAddress,
  makeAddressOption,
  addressOptionsWithOther(addressList) {
    const other = otherAddress()
    if (!addressList)
      return [other]

    const addresses = addressList.map(ad => makeAddressOption(ad))
    return [...addresses, other]
  },
  validateZipCode(zipCode) {
    if(!zipCode.value) return true

    const cleanedZipCode = zipCode?.value.replace(/[.-]/gi, '')
    if(cleanedZipCode?.length !== 8) {
      return false
    }

    return true
  }
}

export default addressUtils
